import React from 'react';
const coverage = [{
  tag: 'Q1',
  label: 'Warm-Up Game',
  body: 'Activation through a game. No laps, no lines.',
  accent: 'text-q1',
  bar: 'border-l-q1'
}, {
  tag: 'Q2',
  label: 'Skill Stations',
  body: 'Rotating stations so nobody waits their turn.',
  accent: 'text-q2',
  bar: 'border-l-q2'
}, {
  tag: 'Q3',
  label: 'Team Install',
  body: 'One new play or concept per week — never ten at once.',
  accent: 'text-q3',
  bar: 'border-l-q3'
}, {
  tag: 'Q4',
  label: 'Live Game',
  body: 'A scrimmage with one focus rule for the day.',
  accent: 'text-q4',
  bar: 'border-l-q4'
}, {
  tag: '✓',
  label: 'Practice Cards',
  body: 'The whole practice on one page, by age and format.',
  accent: 'text-gold',
  bar: 'border-l-gold'
}, {
  tag: '✓',
  label: 'Game-Week Loop',
  body: 'Install, rep, script, play. The week of the game, handled.',
  accent: 'text-turf',
  bar: 'border-l-turf'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-242" data-mp="1b0p9z1ztspvz">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-243" data-mp="1f06g7xn2tr27">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-244" data-mp="1ju16xl13n6as">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-245" data-mp="1ou6t4lolo0lh">
          The 4-Quarter Practice
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75 sm:text-lg" data-id="element-246" data-mp="w5rgu6wurwdu">
          Every practice runs like a game: four quarters, same order, every
          week. The kids learn the routine in two weeks — and you just pick up
          the card.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-247" data-mp="2ch58fg0zh2ht">
          {coverage.map(item => <li key={item.label} className={`rounded-lg border border-navy-line border-l-4 ${item.bar} bg-white/5 px-4 py-3`} data-id="element-248" data-mp="2hj49ukd5xpc4">
              <span className={`flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest ${item.accent}`} data-id="element-249" data-mp="1mszpe8jmz3za">
                <span className="font-display text-sm" data-id="element-250" data-mp="1wryyttc873nc">{item.tag}</span>
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-251" data-mp="191uutkv4l1vt">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}